
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { setSnackError } from '../Reducers/snackErrors';
import { tutorService } from '../Services/tutorService';
import { setSuccessSnack } from '../Reducers/snackSuccess';

export const useGetTutorSessions = () => {
  const [sessions, setSessions] = useState([]);

  const [loading, setLoading] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const dispatch = useDispatch();

  const fetchTutorSessions = async (location_id, semester_id) => {
    if (!location_id || !semester_id) return null;

    setLoading(true);

    try {
      const data = await tutorService.getTutorSessions(location_id, semester_id);
      setSessions(data);
      return data;
    } catch (error) {
      if (error.isAuthError || error.isForbidden) {
        return null;
      }
      if (error.isNetworkError) {
        dispatch(setSnackError({ 
          title: 'Connection Error', 
          body: error.message 
        }));
      } else {
        dispatch(setSnackError({
          title: 'Error found',
          body: error.message || 'Unable to get students.'
        }));
      }
      return null;
    } finally {
      setLoading(false);
    }
  };

  const deleteSession = async (id) => {
    setDeleting(true);
    try {
      const data = await tutorService.deleteTutorSession(id);
      if (data.status === 'Removed') {
        dispatch(setSuccessSnack({
          title: 'Delete',
          body: 'Successfully deleted session.'
        }));
        return true;
      }
      return false;
    } catch (error) {
      if (error.isAuthError || error.isForbidden) {
        return false;
      }
      if (error.isNetworkError) {
        dispatch(setSnackError({ 
          title: 'Connection Error', 
          body: error.message 
        }));
      } else {
        dispatch(setSnackError({
          title: 'Error found',
          body: error.message || 'Unable to get students.'
        }));
      }
      return false;
    } finally {
        setDeleting(false);
    }

  }

  return { 
    deleteSession,
    deleting,
    sessions, 
    loading,
    fetchTutorSessions 
  };
};